import { render } from "./VehicleDescriptionPage.vue?vue&type=template&id=450fc0ba"
import script from "./VehicleDescriptionPage.vue?vue&type=script&lang=js"
export * from "./VehicleDescriptionPage.vue?vue&type=script&lang=js"

import "./VehicleDescriptionPage.vue?vue&type=style&index=0&id=450fc0ba&lang=css"
script.render = render

export default script